import {WebStorageStateStore} from 'oidc-client-ts'
var protocol = window.location.protocol;
var slashes = protocol.concat("//");
var host = slashes.concat(window.location.host);

var silent_redirect_uri_relative = '/authentication/silent';

const configuration = {
  onSigninCallback: async (user) => {
    window.history.replaceState(
          {},
          document.title,
          window.location.pathname
      )
    },
    authority: host,
    client_id: 'spa',
    redirect_uri: host,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    scope: 'openid profile api1 roles offline_access',
    silent_redirect_uri_relative,
    silent_redirect_uri: host+silent_redirect_uri_relative,
    automaticSilentRenew: true,
    useRefreshToken: true,
    filterProtocolClaims: true,
    loadUserInfo: true,
    monitorSession: true,
    triggerAuthFlow: true,
    post_logout_redirect_uri: host
  };
  
  export default configuration;